export enum BulkUploadQueueOperation {
  create = 'create',
  delete = 'delete',
  update = 'update',
  apply = 'apply',
  none = 'none',
}
